//# sourceMappingURL=my-options.interface.js.map


//////////////////
// WEBPACK FOOTER
// ./~/mydatepicker/dist/interfaces/my-options.interface.js
// module id = 1013
// module chunks = 0